import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { dddLabel } from "@/lib/ddd";

export const useDddCounts = (open) => {
  const { api } = useOutletContext();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!open) return;
    api.get("/admin/participants/summary").then((r) => setRows(r.data.by_ddd)).catch(() => {});
  }, [api, open]);
  return rows;
};

export const DddPicker = ({ rows, value, onChange, testPrefix = "ddd-pick" }) => (
  <div className="flex flex-wrap gap-2">
    {rows.length === 0 && <p className="text-sm text-muted-foreground">Nenhum cadastro ainda.</p>}
    {rows.map((r) => {
      const on = value.includes(r.ddd);
      return (
        <button type="button" key={r.ddd} data-testid={`${testPrefix}-${r.ddd}`} aria-pressed={on}
          onClick={() => onChange(on ? value.filter((d) => d !== r.ddd) : [...value, r.ddd])}
          className={`flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors ${on ? "border-zap-deep bg-zap-deep text-white" : "border-zap-line bg-white hover:bg-zap-mist"}`}>
          <b>({r.ddd})</b><span className={on ? "text-white/80" : "text-muted-foreground"}>{dddLabel(r.ddd)}</span>
          <span className={`rounded-full px-2 text-xs font-bold ${on ? "bg-white/20" : "bg-zap-mist text-zap-deep"}`}>{r.count}</span>
        </button>
      );
    })}
  </div>
);
